// @ts-nocheck

import { createSelector } from 'reselect';

import { getKLOrientationStepRulesByStepId } from '../../constants/labels';
import { selectKLOrientationStepMinOddsRuleByOrientationStepId } from '../rules';
import { getStepIdFromProps } from '../user';

const selectStepRules = createSelector(
  [getStepIdFromProps, selectKLOrientationStepMinOddsRuleByOrientationStepId],
  (stepId, minOdds) => getKLOrientationStepRulesByStepId(minOdds)[stepId],
);

const selectKLOrientationStepRulesDetailsProps = createSelector([selectStepRules], (rules) => ({
  rules,
}));

export default selectKLOrientationStepRulesDetailsProps;
